import { useUIStore } from "../state/ui-store";
import { AssetDrawer } from "./asset-drawer";
import { ConnectionStatus } from "./connection-status";
import { ContextOverlay } from "./context-overlay";
import { DocumentView } from "./document-view";
import { FloatingToolbar } from "./floating-toolbar";
import { LeftPanel } from "./left-panel";
import { RightPanel } from "./right-panel";
import { TurnTracker } from "./turn-tracker";

export function Layout() {
  const viewMode = useUIStore((s) => s.viewMode);

  return (
    <div className="absolute inset-0 pointer-events-none flex flex-col h-full w-full">
      {/* Top bar with connection status */}
      <div className="absolute top-2 left-2 z-30 flex items-center gap-2">
        <ConnectionStatus />
      </div>

      <div className="absolute top-12 left-1/2 -translate-x-1/2 z-30">
        <TurnTracker />
      </div>

      <div className="flex-1 flex flex-row items-stretch justify-between relative overflow-hidden">
        {/* Persistent Left Outliner */}
        <LeftPanel />

        {/* Document view takes up central space exclusively if active */}
        {viewMode === "document" && (
          <div className="pointer-events-auto flex-1 flex flex-col items-center justify-center mx-2 z-10 shadow-2xl rounded overflow-hidden">
            <DocumentView />
          </div>
        )}
      </div>

      {/* Floating right panel (aligned with top control groups) */}
      <div className="absolute top-2 bottom-2 right-2 pointer-events-none z-30 flex">
        <RightPanel />
      </div>

      {/* Floating HUDs */}
      <ContextOverlay />
      {viewMode !== "document" && (
        <>
          <FloatingToolbar />
          <AssetDrawer />
        </>
      )}
    </div>
  );
}
